import { __rest } from "tslib";
import { get, writable } from 'svelte/store';
export async function createAsyncItemStore(url) {
    const response = await fetch(url);
    let initialItems;
    if (response && response.ok) {
        initialItems = await response.json();
    }
    else {
        console.error('Request failed', response);
    }
    const store = writable(initialItems);
    const { subscribe, update } = store;
    let createdCounter = 0;
    async function create(created) {
        createdCounter++;
        const tempId = `temp-${createdCounter}`;
        update(s => ([Object.assign(Object.assign({}, created), { displaytext: created.text, id: tempId, isOwn: true, isUnsynced: true }), ...s]));
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(created)
        });
        if (response.ok) {
            const item = await response.json();
            setSynced(item, tempId);
        }
        else {
            setError(tempId, true);
        }
    }
    async function remove(removed) {
        if (typeof removed !== 'object') {
            removed = get(store).find(i => i.id == removed);
        }
        update(s => s.filter(i => i !== removed));
        await fetch(url, {
            method: 'DELETE',
            body: JSON.stringify(removed)
        });
    }
    async function modify(modified) {
        update(s => s.map(i => i.id === modified.id ? modified : i));
        const response = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(modified)
        });
        if (response.ok) {
            const item = await response.json();
            setSynced(item, modified.id);
        }
        else {
            setError(modified.id, true);
        }
    }
    function setSynced(item, id) {
        update(s => s.map(i => {
            if (i.id == id) {
                return Object.assign({}, item);
            }
            return i;
        }));
    }
    function setError(id, hasError) {
        update(s => s.map(i => {
            if (i.id == id) {
                const { hasError } = i, iNew = __rest(i, ["hasError"]);
                if (hasError) {
                    iNew.hasError = true;
                }
                return iNew;
            }
            return i;
        }));
    }
    return {
        subscribe, create, remove, modify
    };
}
